import {
  VersicherungsangabenConfig,
  VersicherungsangabenSectionConfig,
} from '@/features/Versicherungsangaben/types';
import { SECTION } from '@/components/layout/types';
import { beitragsReduzierungSection } from '@/features/Sparten/pfe/formConfigs/inputFormConfig';

const inputConfig: VersicherungsangabenSectionConfig = {
  [SECTION.INPUT_VN]: {
    label: 'Angaben zum Versicherungsnehmer / versicherte Person',
    component: () =>
      import(
        '@/features/Sparten/pfe/sections/input/InputVersicherungsnehmer.vue'
      ),
  },
  [SECTION.INPUT_ABSICHERUNG]: {
    label: 'Gewünschte Absicherung',
    component: () =>
      import('@/features/Sparten/pfe/sections/input/InputAbsicherung.vue'),
  },
  [SECTION.INPUT_BEITRAGSREDUZIERUNG]: {
    label: 'Mögliche Beitragsreduzierung',
    disabledPaths: ['demvRabattiert'],
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/input/InputBeitragsreduzierung.vue'
      ),
    componentProps: {
      'form-config': beitragsReduzierungSection,
    },
  },
};

const contractConfig: VersicherungsangabenSectionConfig = {
  [SECTION.CONTRACT_CLIENT]: {
    label: 'Persönliche Angaben',
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractClient.vue'
      ),
  },
  // [SECTION.CONTRACT_COMPANY_QUESTION]: {
  //   label: 'Gesellschaftsfragen',
  //   requiresContractTariff: true,
  //   component: () =>
  //     import(
  //       '@/features/Sparten/shared/sections/property/contract/ContractCompanyQuestions.vue'
  //     ),
  // },
  [SECTION.PFE_CONTRACT_HORSES]: {
    label: 'Angaben zum Pferd/Pferde',
    component: () =>
      import('@/features/Sparten/pfe/sections/contract/ContractHorses.vue'),
  },
  [SECTION.PFE_CONTRACT_VEREIN]: {
    label: 'Angaben zum Verein',
    component: () =>
      import('@/features/Sparten/pfe/sections/contract/ContractVerein.vue'),
  },
  [SECTION.PFE_CONTRACT_REITBETEILIGUNGEN]: {
    label: 'Angaben zur Reitbeteiligung',
    component: () =>
      import(
        '@/features/Sparten/pfe/sections/contract/ContractReitbeteiligungen.vue'
      ),
  },
  [SECTION.PROPERTY_CONTRACT_PREVIOUS_INSURANCE]: {
    label: 'Vorversicherung',
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractPreviousInsuranceAndDamage.vue'
      ),
  },
  [SECTION.CONTRACT_BANK_TRANSFER_INFORMATION]: {
    label: 'Zahlungsinformation',
    requiresContractTariff: true,
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractBankTransferInformation.vue'
      ),
  },
};

export const pfeVersicherungsangabenConfig: VersicherungsangabenConfig = {
  inputConfig,
  contractConfig,
};
